export default "//static.tradera.net/touchweb/static/output/images/app-download-mobile-2x.ed59fe28.png";